module.exports = __webpack_public_path__ + "img/FORCOAST_Mussel_Logo_White.d820cbee.png";